module.exports = __webpack_public_path__ + "assets/03099e58f3738e300ae31c7ea3eea6ad.png";